import type { SVGProps } from 'react';
const SvgPlaylistAddCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#playlist_add_check_svg__a)">
      <path
        fill="currentColor"
        d="M14 10H2v2h12v-2Zm0-4H2v2h12V6ZM2 16h8v-2H2v2Zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5Z"
      />
    </g>
    <defs>
      <clipPath id="playlist_add_check_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPlaylistAddCheck;
